import React from 'react'
import clsx from 'clsx'
import { UserEdit } from 'iconsax-react'
import { useTheme } from '@mui/material'

import MediaAvatar from '../../../../../atoms/MediaAvatar'

const AuthorSection = ({ classes, allUsers, currentUser, values }) => {
  const user = allUsers[values.created_by]
  const theme = useTheme()
  return (
    <div
      className={clsx(
        classes.center,
        classes.label,
        classes.mobile,
        classes.container
      )}
      style={{ cursor: 'default' }}
    >
      <span className={clsx(classes.center, classes.label)}>
        <UserEdit
          size={theme.size.base}
          variant='Bulk'
          color={theme.palette.primary.main}
        />
        AUTHOR
      </span>

      <span className={classes.center}>
        {!user ? null : (
          <>
            <MediaAvatar user={user} className={classes.avatar} />
            <span className={classes.name}>
              {user.name}
              {user.id === currentUser()?.id ? ' (me)' : ''}
            </span>
          </>
        )}
      </span>
    </div>
  )
}

export default AuthorSection
